import {
	type EnvironmentRepository,
	type HttpService,
	type RepositoryConfiguration,
	RepositoryType
} from '@contexts/shared/domain';
import type { UserRepository } from '@contexts/users/domain';
import {
	inMemoryUserRepositoryBuilder,
	restApiUserRepositoryBuilder
} from '@contexts/users/infrastructure';

import { ENVIRONMENT_REPOSITORY } from '@dependencies/shared';
import { HTTP_SERVICE } from '@dependencies/shared/domain/contracts';

export const USER_REPOSITORY_DEFINITION: RepositoryConfiguration<UserRepository> = {
	[RepositoryType.IN_MEMORY]: {
		factory: () => inMemoryUserRepositoryBuilder(),
		deps: []
	},
	[RepositoryType.REST_API]: {
		factory: (env: EnvironmentRepository, http: HttpService) =>
			restApiUserRepositoryBuilder(env, http),
		deps: [ENVIRONMENT_REPOSITORY, HTTP_SERVICE]
	}
};
